import React, { Component } from 'react';
import './Follow.css';

/**
 * Twitter SVG Icon
 */
export default class IconSvgTwitter extends Component {

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        return (
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 50 50">
				<g transform="translate(32, 1056)">
					<path className="svg-icon-twitter" d="M-7-1055c-13.3,0-24,10.7-24,24s10.7,24,24,24s24-10.7,24-24S6.3-1055-7-1055z M2.5-1035.9c0,0.2,0,0.4,0,0.6
						c0,6.5-4.9,14-14,14c-2.8,0-5.4-0.8-7.6-2.2c0.4,0.1,0.8,0.1,1.2,0.1c2.3,0,4.4-0.8,6.1-2.1c-2.2-0.1-4-1.5-4.6-3.5
						c0.3,0.1,0.6,0.1,0.9,0.1c0.4,0,0.9-0.1,1.3-0.2c-2.2-0.5-4-2.5-4-4.8v-0.1c0.7,0.4,1.4,0.6,2.2,0.6c-1.4-0.9-2.2-2.4-2.2-4.1
						c0-0.9,0.2-1.7,0.7-2.5c2.4,3,6.1,4.9,10.1,5.2c-0.1-0.4-0.2-0.8-0.2-1.1c0-2.7,2.2-4.9,5-4.9c1.4,0,2.7,0.6,3.6,1.6
						c1.1-0.2,2.2-0.6,3.2-1.2c-0.4,1.1-1.1,2.1-2.2,2.7c1-0.1,2-0.4,2.8-0.8C4.3-1037.4,3.5-1036.6,2.5-1035.9z"/>
				</g>
			</svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/follow/IconSvgTwitter.jsx